export default __webpack_public_path__ + "static/media/back-vinyl.906686bb.gif";